import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取职位分页
 * @param {参数} params
 * @returns
 */
export const getPositionPage = (params) => {
  return request({
    url: `${env.officeUrl}/position/page`,
    method: 'POST',
    data: params,
  })
}

/**
 * 保存职位
 * @param {参数} params
 * @returns
 */
export const savePosition = (params) => {
  return request({
    url: `${env.officeUrl}/position/save`,
    method: 'POST',
    data: params,
  })
}

/**
 * 获取职位
 * @param {参数} params
 * @returns
 */
export const getPosition = (params) => {
  return request({
    url: `${env.officeUrl}/position/${params}`,
    method: 'GET',
  })
}

/**
 * 获取职位
 * @param {参数} params
 * @returns
 */
export const changeStatus = (params) => {
  return request({
    url: `${env.officeUrl}/position/changeStatus`,
    method: 'PUT',
    params,
  })
}

/**
 * 获取职位列表
 * @param {参数} params
 * @returns
 */
export const getPositionList = () => {
  return request({
    url: `${env.officeUrl}/position/list`,
    method: 'GET',
  })
}
